<template>
  <div class="container">
    <div class="banner">
      <img src="../../assets/img/zengzhi_banner.png" alt="" />
    </div>
    <div class="titles">全部</div>
    <div class="con">
      <scroller
        :on-refresh="reffor"
        :on-infinite="inffor"
        ref="scrfor"
        class="scroller_con"
        :noDataText="noDataText"
        v-if="cardList.length > 0"
      >
        <div class="con-list">
          <div
            class="list"
            @click="doJumpDetail(index)"
            v-for="(list, index) in cardList"
            :key="index"
          >
            <div class="list-img"><img :src="list.menuImg" alt="" /></div>
            <h1 class="list-name">{{ list.goodsName }}</h1>
            <p class="list-info">
              {{ list.goodsAdv }}
            </p>
            <p class="list-btn"><span>去办理</span></p>
            <!--div class="list-take">
                            <label for="">奖</label>
                            <span>{{ list.goodsPriceStr}}</span>
                        </div-->
          </div>
        </div>
      </scroller>
      <none v-else></none>
    </div>
  </div>
</template>

<script>
import share from "@/components/share.vue";
import none from "@/components/none.vue";
export default {
  components: {
    share,
    none,
  },
  data() {
    return {
      isShowShare: false,
      pageIndex: 1,
      pagemax: 0, //最大页数
      noDataText: "",
      cardList: [],
      busCode: "",
      officeCode: "",
      loading: true,
      appTag: 1, //类型 appTag  0 佳付通  1 富裕钱包
      shopUid: "",
      outOrderCode: "",
    };
  },
  created() {
    document.body.style.backgroundColor = "#fff";
    this.busCode = this.$route.query.busCode;
    this.officeCode = this.$route.query.officeCode;
    this.shopUid = this.$route.query.shopUid;
    this.outOrderCode = this.$route.query.outOrderCode;
    let appTag = this.$route.query.appTag; //类型 appTag  0 佳付通  1 富裕钱包
    if (appTag) {
      this.appTag = appTag;
    }
    if (this.busCode == 8002) {
      document.title = "网申办卡";
    } else {
      document.title = "信用贷款";
    }
    // this.busCode = '8002';
    // this.officeCode = '2307OA0D';
    this.getCardList();
  },
  methods: {
    //跳转到推广页面
    doJumpDetail(_index) {
      let params = {};
      params = this.cardList[_index];
      window.location.href =
        params.goodsUrl +
        `&busCode=${params.busCode}&channelCode=${params.channelCode}&channelType=${params.typeCode}&outOrderCode=${this.outOrderCode}`;
      //this.$router.push({ path: "/business/businessDetail", query: params });
    },
    //点击推广
    doShare() {
      this.isShowShare = true;
    },
    //关闭推广
    doCloseShare() {
      this.isShowShare = false;
    },
    //获取列表数据
    getCardList() {
      var params = {};
      params["busCode"] = this.busCode;
      params["pageSize"] = 10;
      params["pageIndex"] = this.pageIndex;
      params["officeCode"] = this.officeCode;
      params["shopUid"] = this.shopUid;
      params["appTag"] = this.appTag;
      this.$baseUrl("office/v1/h5PageBusExternalShopList", params).then((res) => {
        let data = res.data;
        console.log(data);
        if (data.code == "0000") {
          this.pagemax = data.totalPage;
          if (this.pageIndex == 1) {
            this.cardList = data.busShopInfoVOList;
          } else {
            this.cardList = this.cardList.concat(data.busShopInfoVOList);
            this.noDataText = "没有更多数据";
          }
          this.busUid = data.busUid;
        } else {
          this.$toast(data.msg);
        }
      });
    },
    reffor() {
      //下拉刷新
      this.pageIndex = 1; //重置页数刷新每次页数都是第一页
      setTimeout(
        function () {
          this.getCardList();
          this.$refs.scrfor.finishPullToRefresh(); //刷新完毕关闭刷新的转圈圈
        }.bind(this),
        1700
      );
    },
    inffor(done) {
      //上拉加载
      if (this.pageIndex >= this.pagemax) {
        this.$refs.scrfor.finishInfinite(true); //这个方法是不让它加载了，显示“没有更多数据”，要不然会一直转圈圈
      } else {
        setTimeout(() => {
          this.pageIndex++; //下拉一次页数+1
          this.getCardList();
          done(); //进行下一次加载操作
        }, 1500);
      }
    },
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#F7F7F7");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
};
</script>

<style scoped>
.container {
  margin: 0 auto;
  max-width: 500px;
}
.banner {
  width: 100%;
  /* height: 80px; */
}
.banner img {
  display: block;
  width: 100%;
}
.titles {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  padding: 20px 15px;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}
.con {
  /* position: absolute;
  width: calc(100% - 30px);
  height: calc(100% - 146px);
  top: 146px;
  left: 0; */
  position: relative;
  height: calc(100vh - 146px);
  margin: 0 15px;
  font-family: PingFang SC;
}
.con-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.list {
  width: calc((100% - 15px) / 2);
  /* height: 155px; */
  background: #fff;
  margin-bottom: 15px;
  padding: 15px 0;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #f2f2f2;
}
.list .list-img {
  width: 52px;
  height: 52px;
  margin: 0 auto 11px;
}
.list .list-img img {
  width: 100%;
}
.list .list-name {
  font-size: 16px;
  text-align: center;
  line-height: 22px;
  margin: 0 0 5px;
}
.list .list-info {
  color: #b1b1b1;
  font-size: 12px;
  text-align: center;
  margin: 0 25px;
  line-height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.list .list-btn {
  margin-top: 5px;
  text-align: center;
}
.list .list-btn span {
  display: inline-block;
  padding: 0 15px;
  height: 20px;
  font-size: 12px;
  color: #fff;
  line-height: 20px;
  border-radius: 10px;
  background: #39a9ed;
}
.list-take {
  height: 28px;
  line-height: 28px;
  background: #ffe6e7;
  color: #ef3c35;
  margin: 10px 26px 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.list-take label {
  background: #ef3c35;
  color: #fff;
  border-radius: 4px;
  width: 28px;
  flex-shrink: 0;
  text-align: center;
  font-size: 14px;
}
.list-take span {
  display: block;
  text-align: center;
  width: 100%;
  font-weight: bold;
  font-size: 16px;
}
@media screen and (max-width: 370px) {
  .list-take span {
    font-size: 14px;
  }
}
</style>
